import {
  endOfDay,
  startOfDay,
  startOfHour,
  subDays,
  subHours,
  subMonths,
} from 'date-fns';
import type { DateRange } from '@logspot-platform/widgets';

export type DateRangePreset = {
  label: string;
  range: () => DateRange;
};

// Simplified version of the legacy embed's react-date-range presets.
export const DATE_RANGE_PRESETS: DateRangePreset[] = [
  {
    label: 'Last 24 hours',
    range: () => {
      const now = startOfHour(new Date());
      return {
        label: 'Last 24 hours',
        interval: '1 hour',
        period: { hours: 24 },
        startDate: startOfHour(subHours(now, 24)),
        endDate: now,
      };
    },
  },
  {
    label: 'Last 7 days',
    range: () => {
      const now = endOfDay(new Date());
      return {
        label: 'Last 7 days',
        interval: '1 days',
        period: { days: 7 },
        startDate: startOfDay(subDays(now, 7)),
        endDate: now,
      };
    },
  },
  {
    label: 'Last 30 days',
    range: () => {
      const now = endOfDay(new Date());
      return {
        label: 'Last 30 days',
        interval: '1 days',
        period: { days: 30 },
        startDate: startOfDay(subDays(now, 30)),
        endDate: now,
      };
    },
  },
  {
    label: 'Last 3 months',
    range: () => {
      const now = endOfDay(new Date());
      return {
        label: 'Last 3 months',
        interval: '1 days',
        period: { months: 3 },
        startDate: startOfDay(subMonths(now, 3)),
        endDate: now,
      };
    },
  },
];

// Matches the legacy embed's default selection (ranges[2] = Last 30 days).
export const DEFAULT_PRESET_INDEX = 2;
